export enum PackageStatatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export const PackageStatusLabels = {
  [PackageStatatusEnum.ACTIVE]: 'Ativo',
  [PackageStatatusEnum.INACTIVE]: 'Inativo'
}